import React, { useEffect } from "react";
import Categories from "../shared/Categories/Categories";
import HomeBanner from "./HomeBanner";
import Map from "./Map";
import Fullpage, {
  FullPageSections,
  FullpageSection,
  FullpageNavigation,
} from "@ap.cx/react-fullpage";
import Header from "../shared/Header/Header";
import Footer from "../shared/Footer/Footer";
import { useWindowSize } from "../../hooks/windowDimensions";
import Layout from "../shared/Layout/Layout";
import CategoriesMobile from "../shared/Categories/CategoriesMobile";
import CookieConsent from "react-cookie-consent";

function Home() {
  const { width } = useWindowSize();

  useEffect(() => {
    document.title = "Home - MetaWorldX";
  }, []);

  return (
    <>
      {width > 1200 ? (
        <div>
          <Fullpage>
            <FullpageNavigation />
            <Header />
            <FullPageSections>
              <FullpageSection>
                <HomeBanner />
              </FullpageSection>
              <FullpageSection>
                <div>
                  <Categories />
                </div>
              </FullpageSection>
              <FullpageSection>
                <Map />
                <Footer />
              </FullpageSection>
            </FullPageSections>
          </Fullpage>
          <CookieConsent
            declineButtonText="Decline"
            buttonText="Understand"
            debug
            expires={365}
            enableDeclineButton
            declineButtonStyle={{
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#24a0ed",
              borderRadius: "5px",
            }}
            buttonStyle={{
              fontWeight: "bold",
              color: "white",
              backgroundColor: "#24a0ed",
              borderRadius: "5px",
            }}
          >
            We use cookies to provide a personalized site experience. By
            continuing to use & browse this site, you agree to our{" "}
            <a
              href="/privacy"
              target="_blank"
              className="text-[white] hover:text-[white] underline"
            >
              Privacy Policy
            </a>
          </CookieConsent>
        </div>
      ) : (
        <Layout>
          <HomeBanner />
          <CategoriesMobile />
          <Map />
        </Layout>
      )}
    </>
  );
}

export default Home;
